import React from 'react';

const HelpProgress = ({ current, total }) => (
    <div className="mt-1" aria-label={`Tutorial step ${current} of ${total}`}>
        <p className="text-xs font-semibold uppercase tracking-wide text-indigo-700">
            Step {current} of {total}
        </p>
        <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-indigo-100" aria-hidden="true">
            <div
                className="help-tour-motion h-full rounded-full bg-normative-blue transition-[width] duration-200"
                style={{ width: `${(current / total) * 100}%` }}
            />
        </div>
    </div>
);

export default HelpProgress;
